import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";

/**
 * Universal fallback preview for AI-deployed sites.
 * In production, the real URL is `https://{slug}.optivize.digital` (wildcard DNS)
 * or `https://optivize.digital/site/{slug}` (this page). The backend already serves
 * the generated HTML at /api/sites/{slug}/html, so we just iframe it here so the
 * site looks "deployed" while sitting on optivize.digital.
 */
export default function SitePreview() {
  const { slug } = useParams();
  const [loaded, setLoaded] = useState(false);
  const [exists, setExists] = useState(true);
  const backend = process.env.REACT_APP_BACKEND_URL;
  const htmlUrl = `${backend}/api/sites/${slug}/html`;

  useEffect(() => {
    let alive = true;
    fetch(`${backend}/api/sites/${slug}`).then(r => { if (alive) setExists(r.ok); }).catch(() => { if (alive) setExists(false); });
    return () => { alive = false; };
  }, [backend, slug]);

  if (!exists) {
    return (
      <div className="section text-center" data-testid="site-not-found">
        <h1 className="text-4xl font-black text-white" style={{fontFamily:'Outfit'}}>Site not found</h1>
        <p className="text-slate-400 mt-3">No published site at <code className="text-cyan-300">/{slug}</code>.</p>
      </div>
    );
  }

  return (
    <div className="w-full" style={{ minHeight: "calc(100vh - 64px)" }} data-testid="site-preview-wrap">
      {!loaded && (
        <div className="flex items-center justify-center py-32 text-slate-400">
          <Loader2 className="animate-spin mr-2"/> Loading site…
        </div>
      )}
      <iframe
        src={htmlUrl}
        title={`site-${slug}`}
        onLoad={() => setLoaded(true)}
        style={{ width: "100%", border: 0, minHeight: "calc(100vh - 64px)", display: loaded ? "block" : "none" }}
        data-testid="site-iframe"
      />
    </div>
  );
}
